import { render, staticRenderFns } from "./Discovery.vue?vue&type=template&id=e6ba570e&scoped=true"
import script from "./Discovery.vue?vue&type=script&lang=js"
export * from "./Discovery.vue?vue&type=script&lang=js"
import style0 from "./Discovery.vue?vue&type=style&index=0&id=e6ba570e&prod&scoped=true&lang=css"
import style1 from "./Discovery.vue?vue&type=style&index=1&id=e6ba570e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6ba570e",
  null
  
)

export default component.exports